// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__bd4Sx","title":"style__title__fbCxh","description":"style__description__rSAey","component":"style__component__bWmF4"};